<template>
  <section class="store-vehicle__index column-index">
    <change-store></change-store>
    <column-info :column-list="columnList"></column-info>
  </section>
</template>

<script>
import ChangeStore from '../components/ChangeStore'
import ColumnInfo from '../components/ColumnInfo'
import authApi from '../../common/auth'

export default {
  components: {
    ChangeStore,
    ColumnInfo
  },
  data() {
    return {
      defaultColumns: [
        {
          title: '车辆登记',
          hasAuth: true,
          items: [
            {
              name: '有牌到店',
              icon: 'carregister',
              link: '/carregister/index'
            }
          ]
        },
        {
          title: '车辆放行',
          hasAuth: true,
          items: [
            {
              name: '与我相关',
              icon: 'my-payment',
              link: '/barriergate/check/list'
            },
            {
              name: '全部车辆',
              icon: 'barriergate-all',
              link: '/barriergate/all/list'
            }
          ]
        },
        {
          title: '数据统计',
          hasAuth: true,
          items: [
            {
              name: '进出店统计',
              icon: 'car-visit-daily',
              link: '/manageAnalysis/carVisitDaily'
            }
          ]
        }
      ]
    }
  },
  created () {
    this.setColumnAuth()
  },
  methods: {
    async setApplyUnlicensed() {
      const { code, data = {} } = await this.$rest.common.getCurrentUserInfo()
      if (code !== 0) return
      if (data.can_apply_unlicensed_exit_requisition) {
        this.defaultColumns[0].items.push({
          name: '无牌离店',
          icon: 'un-leave',
          link: '/leaveRegisterNotPlate/index'
        })
      }
    },
    async setColumnAuth () {
      const auth = await this.$store.state.promiseAuth
      const { authList } = auth
      // 有 有牌离店登记权限，显示有牌离店登记模块
      if (authList.includes(authApi.leaveStore.car_visit_checkout)) {
        this.defaultColumns[0].items.push({
          name: '有牌离店',
          icon: 'leave-register',
          link: '/leaveRegister/index'
        })
      }

      if (authList.includes(authApi.leaveStore.car_visit_checkout_confirm)) {
        this.defaultColumns[1].items.push({
          name: '无牌放行',
          icon: 'ic-leave',
          link: '/barriergate/unlabeled/discharging'
        })
      }

      const viewSelf = authList.includes(authApi.busiAnalysis.view_self)
      let carVisitAuth = false

      if (viewSelf) {
        carVisitAuth = true
      } else {
        carVisitAuth = authList.includes(authApi.busiAnalysis.visit_car)
      }
      if (!carVisitAuth) {
        this.defaultColumns[2].hasAuth = false
      }
      // 设置无牌离店
      this.setApplyUnlicensed()
    }
  },
  computed: {
    columnList () {
      return this.defaultColumns.filter(column => column.hasAuth === true)
    }
  }
}
</script>

<style lang="less">
  @import "../../stylesheets/base/fn.less";
  @import "../../stylesheets/modules/manage/columnList.less";
  .store-vehicle__index {
    .column {
      @selectors: carregister, leave-register, my-payment, barriergate-all, car-visit-daily,ic-leave,un-leave;
      each(@selectors, {
        .@{value} {
          background: url('../../stylesheets/images/index/@{value}.png') no-repeat center center / cover;
          background-size: contain;
        }
      })
    }
  }
</style>
